'use client';
import { useSuspenseQuery } from '@apollo/client/react';
import { FC, PropsWithChildren } from 'react';

import { ImageGeneration } from '@/.gql/graphql';
import { GET_IMAGE_GENERATION } from '@/.graphql';

import { createCustomContext } from './context';

const [Context, useFindGenerationContext] =
  createCustomContext<ImageGeneration | null>({
    name: 'useFindGenerationContext',
    strict: false,
  });
export { useFindGenerationContext };

interface Props extends PropsWithChildren {
  imageGenerationId: string;
}

export const FindGenerationProvider: FC<Props> = ({
  children,
  imageGenerationId,
}) => {
  const data = useSuspenseQuery(GET_IMAGE_GENERATION, {
    variables: {
      imageGenerationId,
    },
  }).data?.getImageGeneration;

  return <Context value={data}>{children}</Context>;
};
